<template>
  <div class="power-ups">
    <power-up></power-up>
  </div>
</template>

<script>
export default {
  name: "PowerUps"
};
</script>

<style lang="scss" scoped>
</style>